import { useNavigate } from "react-router-dom";
import pageImg from "../../assets/40.webp";
import Button from "../Button";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="relative flex flex-col items-center justify-center w-full h-screen bg-palette-5">
      <img
        className="object-contain w-full h-full"
        loading="lazy"
        src={pageImg}
      />
      <div className="absolute bottom-56 lg:bottom-4 md:bottom-72">
        <Button
          onClick={() => {
            navigate(-1);
          }}
          selfLabel="Go Back"
          className="px-6 py-3 font-semibold text-palette-5 bg-palette-2"
        />
      </div>
    </div>
  );
};

export default PageNotFound;
